module.exports = __webpack_public_path__ + "img/calendar.68250af8.svg";